import React, { useState } from "react";
import Button from "../UI/Button";
import Input from "../UI/Input";

const API_BASE = "https://marchedeluxe.ch/services";

const ResetPasswordView = ({ token, t = {}, onDone }) => {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!token) {
      setError("Lien invalide ou manquant.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/reset_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          password: formData.password,
          confirmPassword: formData.confirmPassword,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data?.success) {
        throw new Error(data?.message || "Réinitialisation impossible.");
      }

      setMessage(
        data?.message || "Votre mot de passe a été réinitialisé avec succès."
      );
      setFormData({ password: "", confirmPassword: "" });
    } catch (err) {
      setError(err?.message || "Erreur lors de la réinitialisation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-luxury-container page-transition">
      <div className="auth-central-card">
        <div className="auth-header">
          <h1>{t.resetPasswordTitle || "Nouveau mot de passe"}</h1>
          <p>
            {t.resetPasswordSubtitle ||
              "Choisissez un nouveau mot de passe pour votre compte."}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form-luxury">
          <Input
            label={t.password || "Mot de passe"}
            type="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />

          <Input
            label={t.confirmPassword || "Confirmer le mot de passe"}
            type="password"
            value={formData.confirmPassword}
            onChange={(e) =>
              setFormData({ ...formData, confirmPassword: e.target.value })
            }
            required
          />

          {error && <p className="auth-error">{error}</p>}
          {message && <p className="auth-success">{message}</p>}

          <Button type="submit" variant="gold" fullWidth disabled={loading}>
            {loading
              ? t.processing || "Traitement..."
              : t.resetPasswordAction || "RÉINITIALISER LE MOT DE PASSE"}
          </Button>
        </form>

        <div className="auth-footer">
          <button
            type="button"
            onClick={() => onDone?.()}
            className="auth-switch-btn"
          >
            {t.backToLogin || "Retour à la connexion"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordView;
